/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as OnboardingImport } from './routes/onboarding'
import { Route as IndexImport } from './routes/index'
import { Route as OauthLayoutImport } from './routes/oauth/_layout'
import { Route as ExternalAuthImport } from './routes/external/auth'
import { Route as DashboardLayoutImport } from './routes/dashboard/_layout'
import { Route as AuthLayoutImport } from './routes/auth/_layout'
import { Route as DashboardLayoutIndexImport } from './routes/dashboard/_layout.index'
import { Route as AuthLayoutIndexImport } from './routes/auth/_layout.index'
import { Route as OauthLayoutGoogleImport } from './routes/oauth/_layout.google'
import { Route as OauthLayoutFacebookImport } from './routes/oauth/_layout.facebook'
import { Route as DashboardSettingsLayoutImport } from './routes/dashboard/settings/_layout'
import { Route as DashboardResearchLayoutImport } from './routes/dashboard/research/_layout'
import { Route as DashboardChatSessionImport } from './routes/dashboard/chat/$session'
import { Route as DashboardLayoutResearchImport } from './routes/dashboard/_layout.research'
import { Route as DashboardLayoutProductsImport } from './routes/dashboard/_layout.products'
import { Route as DashboardLayoutLibraryImport } from './routes/dashboard/_layout.library'
import { Route as DashboardLayoutCommunityImport } from './routes/dashboard/_layout.community'
import { Route as DashboardLayoutChatsImport } from './routes/dashboard/_layout.chats'
import { Route as DashboardLayoutBrandImport } from './routes/dashboard/_layout.brand'
import { Route as ChatRSessionImport } from './routes/chat/r.$session'
import { Route as ChatPSessionImport } from './routes/chat/p.$session'
import { Route as DashboardSettingsLayoutUsageImport } from './routes/dashboard/settings/_layout.usage'
import { Route as DashboardSettingsLayoutSubscriptionImport } from './routes/dashboard/settings/_layout.subscription'
import { Route as DashboardSettingsLayoutProfileImport } from './routes/dashboard/settings/_layout.profile'
import { Route as DashboardSettingsLayoutInvoicesImport } from './routes/dashboard/settings/_layout.invoices'
import { Route as DashboardResearchLayoutIdImport } from './routes/dashboard/research/_layout.$id'
import { Route as AuthLayoutCallbackMagicLinkImport } from './routes/auth/_layout.callback.magic-link'
import { Route as AuthLayoutCallbackGoogleImport } from './routes/auth/_layout.callback.google'
import { Route as DashboardResearchLayoutIdIndexImport } from './routes/dashboard/research/_layout.$id.index'
import { Route as DashboardResearchLayoutIdSocialImport } from './routes/dashboard/research/_layout.$id.social'
import { Route as DashboardResearchLayoutIdMarketImport } from './routes/dashboard/research/_layout.$id.market'
import { Route as DashboardResearchLayoutIdFoundationImport } from './routes/dashboard/research/_layout.$id.foundation'
import { Route as DashboardResearchLayoutIdCreativeImport } from './routes/dashboard/research/_layout.$id.creative'
import { Route as DashboardResearchLayoutIdCompetitiveImport } from './routes/dashboard/research/_layout.$id.competitive'
import { Route as DashboardResearchLayoutIdAudienceImport } from './routes/dashboard/research/_layout.$id.audience'

// Create Virtual Routes

const OauthImport = createFileRoute('/oauth')()
const DashboardImport = createFileRoute('/dashboard')()
const AuthImport = createFileRoute('/auth')()
const DashboardSettingsImport = createFileRoute('/dashboard/settings')()
const DashboardResearchImport = createFileRoute('/dashboard/research')()

// Create/Update Routes

const OauthRoute = OauthImport.update({
  id: '/oauth',
  path: '/oauth',
  getParentRoute: () => rootRoute,
} as any)

const DashboardRoute = DashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRoute,
} as any)

const OnboardingRoute = OnboardingImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const DashboardSettingsRoute = DashboardSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardResearchRoute = DashboardResearchImport.update({
  id: '/research',
  path: '/research',
  getParentRoute: () => DashboardRoute,
} as any)

const OauthLayoutRoute = OauthLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => OauthRoute,
} as any)

const ExternalAuthRoute = ExternalAuthImport.update({
  id: '/external/auth',
  path: '/external/auth',
  getParentRoute: () => rootRoute,
} as any)

const DashboardLayoutRoute = DashboardLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => DashboardRoute,
} as any)

const AuthLayoutRoute = AuthLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AuthRoute,
} as any)

const DashboardLayoutIndexRoute = DashboardLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardLayoutRoute,
} as any)

const AuthLayoutIndexRoute = AuthLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthLayoutRoute,
} as any)

const OauthLayoutGoogleRoute = OauthLayoutGoogleImport.update({
  id: '/google',
  path: '/google',
  getParentRoute: () => OauthLayoutRoute,
} as any)

const OauthLayoutFacebookRoute = OauthLayoutFacebookImport.update({
  id: '/facebook',
  path: '/facebook',
  getParentRoute: () => OauthLayoutRoute,
} as any)

const DashboardSettingsLayoutRoute = DashboardSettingsLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => DashboardSettingsRoute,
} as any)

const DashboardResearchLayoutRoute = DashboardResearchLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => DashboardResearchRoute,
} as any)

const DashboardChatSessionRoute = DashboardChatSessionImport.update({
  id: '/chat/$session',
  path: '/chat/$session',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardLayoutResearchRoute = DashboardLayoutResearchImport.update({
  id: '/research',
  path: '/research',
  getParentRoute: () => DashboardLayoutRoute,
} as any)

const DashboardLayoutProductsRoute = DashboardLayoutProductsImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => DashboardLayoutRoute,
} as any)

const DashboardLayoutLibraryRoute = DashboardLayoutLibraryImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => DashboardLayoutRoute,
} as any)

const DashboardLayoutCommunityRoute = DashboardLayoutCommunityImport.update({
  id: '/community',
  path: '/community',
  getParentRoute: () => DashboardLayoutRoute,
} as any)

const DashboardLayoutChatsRoute = DashboardLayoutChatsImport.update({
  id: '/chats',
  path: '/chats',
  getParentRoute: () => DashboardLayoutRoute,
} as any)

const DashboardLayoutBrandRoute = DashboardLayoutBrandImport.update({
  id: '/brand',
  path: '/brand',
  getParentRoute: () => DashboardLayoutRoute,
} as any)

const ChatRSessionRoute = ChatRSessionImport.update({
  id: '/chat/r/$session',
  path: '/chat/r/$session',
  getParentRoute: () => rootRoute,
} as any)

const ChatPSessionRoute = ChatPSessionImport.update({
  id: '/chat/p/$session',
  path: '/chat/p/$session',
  getParentRoute: () => rootRoute,
} as any)

const DashboardSettingsLayoutUsageRoute =
  DashboardSettingsLayoutUsageImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => DashboardSettingsLayoutRoute,
  } as any)

const DashboardSettingsLayoutSubscriptionRoute =
  DashboardSettingsLayoutSubscriptionImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => DashboardSettingsLayoutRoute,
  } as any)

const DashboardSettingsLayoutProfileRoute =
  DashboardSettingsLayoutProfileImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => DashboardSettingsLayoutRoute,
  } as any)

const DashboardSettingsLayoutInvoicesRoute =
  DashboardSettingsLayoutInvoicesImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => DashboardSettingsLayoutRoute,
  } as any)

const DashboardResearchLayoutIdRoute = DashboardResearchLayoutIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => DashboardResearchLayoutRoute,
} as any)

const AuthLayoutCallbackMagicLinkRoute =
  AuthLayoutCallbackMagicLinkImport.update({
    id: '/callback/magic-link',
    path: '/callback/magic-link',
    getParentRoute: () => AuthLayoutRoute,
  } as any)

const AuthLayoutCallbackGoogleRoute = AuthLayoutCallbackGoogleImport.update({
  id: '/callback/google',
  path: '/callback/google',
  getParentRoute: () => AuthLayoutRoute,
} as any)

const DashboardResearchLayoutIdIndexRoute =
  DashboardResearchLayoutIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardResearchLayoutIdRoute,
  } as any)

const DashboardResearchLayoutIdSocialRoute =
  DashboardResearchLayoutIdSocialImport.update({
    id: '/social',
    path: '/social',
    getParentRoute: () => DashboardResearchLayoutIdRoute,
  } as any)

const DashboardResearchLayoutIdMarketRoute =
  DashboardResearchLayoutIdMarketImport.update({
    id: '/market',
    path: '/market',
    getParentRoute: () => DashboardResearchLayoutIdRoute,
  } as any)

const DashboardResearchLayoutIdFoundationRoute =
  DashboardResearchLayoutIdFoundationImport.update({
    id: '/foundation',
    path: '/foundation',
    getParentRoute: () => DashboardResearchLayoutIdRoute,
  } as any)

const DashboardResearchLayoutIdCreativeRoute =
  DashboardResearchLayoutIdCreativeImport.update({
    id: '/creative',
    path: '/creative',
    getParentRoute: () => DashboardResearchLayoutIdRoute,
  } as any)

const DashboardResearchLayoutIdCompetitiveRoute =
  DashboardResearchLayoutIdCompetitiveImport.update({
    id: '/competitive',
    path: '/competitive',
    getParentRoute: () => DashboardResearchLayoutIdRoute,
  } as any)

const DashboardResearchLayoutIdAudienceRoute =
  DashboardResearchLayoutIdAudienceImport.update({
    id: '/audience',
    path: '/audience',
    getParentRoute: () => DashboardResearchLayoutIdRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingImport
      parentRoute: typeof rootRoute
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/auth/_layout': {
      id: '/auth/_layout'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthLayoutImport
      parentRoute: typeof AuthRoute
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/_layout': {
      id: '/dashboard/_layout'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardLayoutImport
      parentRoute: typeof DashboardRoute
    }
    '/external/auth': {
      id: '/external/auth'
      path: '/external/auth'
      fullPath: '/external/auth'
      preLoaderRoute: typeof ExternalAuthImport
      parentRoute: typeof rootRoute
    }
    '/oauth': {
      id: '/oauth'
      path: '/oauth'
      fullPath: '/oauth'
      preLoaderRoute: typeof OauthImport
      parentRoute: typeof rootRoute
    }
    '/oauth/_layout': {
      id: '/oauth/_layout'
      path: '/oauth'
      fullPath: '/oauth'
      preLoaderRoute: typeof OauthLayoutImport
      parentRoute: typeof OauthRoute
    }
    '/chat/p/$session': {
      id: '/chat/p/$session'
      path: '/chat/p/$session'
      fullPath: '/chat/p/$session'
      preLoaderRoute: typeof ChatPSessionImport
      parentRoute: typeof rootRoute
    }
    '/chat/r/$session': {
      id: '/chat/r/$session'
      path: '/chat/r/$session'
      fullPath: '/chat/r/$session'
      preLoaderRoute: typeof ChatRSessionImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/_layout/brand': {
      id: '/dashboard/_layout/brand'
      path: '/brand'
      fullPath: '/dashboard/brand'
      preLoaderRoute: typeof DashboardLayoutBrandImport
      parentRoute: typeof DashboardLayoutImport
    }
    '/dashboard/_layout/chats': {
      id: '/dashboard/_layout/chats'
      path: '/chats'
      fullPath: '/dashboard/chats'
      preLoaderRoute: typeof DashboardLayoutChatsImport
      parentRoute: typeof DashboardLayoutImport
    }
    '/dashboard/_layout/community': {
      id: '/dashboard/_layout/community'
      path: '/community'
      fullPath: '/dashboard/community'
      preLoaderRoute: typeof DashboardLayoutCommunityImport
      parentRoute: typeof DashboardLayoutImport
    }
    '/dashboard/_layout/library': {
      id: '/dashboard/_layout/library'
      path: '/library'
      fullPath: '/dashboard/library'
      preLoaderRoute: typeof DashboardLayoutLibraryImport
      parentRoute: typeof DashboardLayoutImport
    }
    '/dashboard/_layout/products': {
      id: '/dashboard/_layout/products'
      path: '/products'
      fullPath: '/dashboard/products'
      preLoaderRoute: typeof DashboardLayoutProductsImport
      parentRoute: typeof DashboardLayoutImport
    }
    '/dashboard/_layout/research': {
      id: '/dashboard/_layout/research'
      path: '/research'
      fullPath: '/dashboard/research'
      preLoaderRoute: typeof DashboardLayoutResearchImport
      parentRoute: typeof DashboardLayoutImport
    }
    '/dashboard/chat/$session': {
      id: '/dashboard/chat/$session'
      path: '/chat/$session'
      fullPath: '/dashboard/chat/$session'
      preLoaderRoute: typeof DashboardChatSessionImport
      parentRoute: typeof DashboardImport
    }
    '/dashboard/research': {
      id: '/dashboard/research'
      path: '/research'
      fullPath: '/dashboard/research'
      preLoaderRoute: typeof DashboardResearchImport
      parentRoute: typeof DashboardImport
    }
    '/dashboard/research/_layout': {
      id: '/dashboard/research/_layout'
      path: '/research'
      fullPath: '/dashboard/research'
      preLoaderRoute: typeof DashboardResearchLayoutImport
      parentRoute: typeof DashboardResearchRoute
    }
    '/dashboard/settings': {
      id: '/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof DashboardSettingsImport
      parentRoute: typeof DashboardImport
    }
    '/dashboard/settings/_layout': {
      id: '/dashboard/settings/_layout'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof DashboardSettingsLayoutImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/oauth/_layout/facebook': {
      id: '/oauth/_layout/facebook'
      path: '/facebook'
      fullPath: '/oauth/facebook'
      preLoaderRoute: typeof OauthLayoutFacebookImport
      parentRoute: typeof OauthLayoutImport
    }
    '/oauth/_layout/google': {
      id: '/oauth/_layout/google'
      path: '/google'
      fullPath: '/oauth/google'
      preLoaderRoute: typeof OauthLayoutGoogleImport
      parentRoute: typeof OauthLayoutImport
    }
    '/auth/_layout/': {
      id: '/auth/_layout/'
      path: '/'
      fullPath: '/auth/'
      preLoaderRoute: typeof AuthLayoutIndexImport
      parentRoute: typeof AuthLayoutImport
    }
    '/dashboard/_layout/': {
      id: '/dashboard/_layout/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardLayoutIndexImport
      parentRoute: typeof DashboardLayoutImport
    }
    '/auth/_layout/callback/google': {
      id: '/auth/_layout/callback/google'
      path: '/callback/google'
      fullPath: '/auth/callback/google'
      preLoaderRoute: typeof AuthLayoutCallbackGoogleImport
      parentRoute: typeof AuthLayoutImport
    }
    '/auth/_layout/callback/magic-link': {
      id: '/auth/_layout/callback/magic-link'
      path: '/callback/magic-link'
      fullPath: '/auth/callback/magic-link'
      preLoaderRoute: typeof AuthLayoutCallbackMagicLinkImport
      parentRoute: typeof AuthLayoutImport
    }
    '/dashboard/research/_layout/$id': {
      id: '/dashboard/research/_layout/$id'
      path: '/$id'
      fullPath: '/dashboard/research/$id'
      preLoaderRoute: typeof DashboardResearchLayoutIdImport
      parentRoute: typeof DashboardResearchLayoutImport
    }
    '/dashboard/settings/_layout/invoices': {
      id: '/dashboard/settings/_layout/invoices'
      path: '/invoices'
      fullPath: '/dashboard/settings/invoices'
      preLoaderRoute: typeof DashboardSettingsLayoutInvoicesImport
      parentRoute: typeof DashboardSettingsLayoutImport
    }
    '/dashboard/settings/_layout/profile': {
      id: '/dashboard/settings/_layout/profile'
      path: '/profile'
      fullPath: '/dashboard/settings/profile'
      preLoaderRoute: typeof DashboardSettingsLayoutProfileImport
      parentRoute: typeof DashboardSettingsLayoutImport
    }
    '/dashboard/settings/_layout/subscription': {
      id: '/dashboard/settings/_layout/subscription'
      path: '/subscription'
      fullPath: '/dashboard/settings/subscription'
      preLoaderRoute: typeof DashboardSettingsLayoutSubscriptionImport
      parentRoute: typeof DashboardSettingsLayoutImport
    }
    '/dashboard/settings/_layout/usage': {
      id: '/dashboard/settings/_layout/usage'
      path: '/usage'
      fullPath: '/dashboard/settings/usage'
      preLoaderRoute: typeof DashboardSettingsLayoutUsageImport
      parentRoute: typeof DashboardSettingsLayoutImport
    }
    '/dashboard/research/_layout/$id/audience': {
      id: '/dashboard/research/_layout/$id/audience'
      path: '/audience'
      fullPath: '/dashboard/research/$id/audience'
      preLoaderRoute: typeof DashboardResearchLayoutIdAudienceImport
      parentRoute: typeof DashboardResearchLayoutIdImport
    }
    '/dashboard/research/_layout/$id/competitive': {
      id: '/dashboard/research/_layout/$id/competitive'
      path: '/competitive'
      fullPath: '/dashboard/research/$id/competitive'
      preLoaderRoute: typeof DashboardResearchLayoutIdCompetitiveImport
      parentRoute: typeof DashboardResearchLayoutIdImport
    }
    '/dashboard/research/_layout/$id/creative': {
      id: '/dashboard/research/_layout/$id/creative'
      path: '/creative'
      fullPath: '/dashboard/research/$id/creative'
      preLoaderRoute: typeof DashboardResearchLayoutIdCreativeImport
      parentRoute: typeof DashboardResearchLayoutIdImport
    }
    '/dashboard/research/_layout/$id/foundation': {
      id: '/dashboard/research/_layout/$id/foundation'
      path: '/foundation'
      fullPath: '/dashboard/research/$id/foundation'
      preLoaderRoute: typeof DashboardResearchLayoutIdFoundationImport
      parentRoute: typeof DashboardResearchLayoutIdImport
    }
    '/dashboard/research/_layout/$id/market': {
      id: '/dashboard/research/_layout/$id/market'
      path: '/market'
      fullPath: '/dashboard/research/$id/market'
      preLoaderRoute: typeof DashboardResearchLayoutIdMarketImport
      parentRoute: typeof DashboardResearchLayoutIdImport
    }
    '/dashboard/research/_layout/$id/social': {
      id: '/dashboard/research/_layout/$id/social'
      path: '/social'
      fullPath: '/dashboard/research/$id/social'
      preLoaderRoute: typeof DashboardResearchLayoutIdSocialImport
      parentRoute: typeof DashboardResearchLayoutIdImport
    }
    '/dashboard/research/_layout/$id/': {
      id: '/dashboard/research/_layout/$id/'
      path: '/'
      fullPath: '/dashboard/research/$id/'
      preLoaderRoute: typeof DashboardResearchLayoutIdIndexImport
      parentRoute: typeof DashboardResearchLayoutIdImport
    }
  }
}

// Create and export the route tree

interface AuthLayoutRouteChildren {
  AuthLayoutIndexRoute: typeof AuthLayoutIndexRoute
  AuthLayoutCallbackGoogleRoute: typeof AuthLayoutCallbackGoogleRoute
  AuthLayoutCallbackMagicLinkRoute: typeof AuthLayoutCallbackMagicLinkRoute
}

const AuthLayoutRouteChildren: AuthLayoutRouteChildren = {
  AuthLayoutIndexRoute: AuthLayoutIndexRoute,
  AuthLayoutCallbackGoogleRoute: AuthLayoutCallbackGoogleRoute,
  AuthLayoutCallbackMagicLinkRoute: AuthLayoutCallbackMagicLinkRoute,
}

const AuthLayoutRouteWithChildren = AuthLayoutRoute._addFileChildren(
  AuthLayoutRouteChildren,
)

interface AuthRouteChildren {
  AuthLayoutRoute: typeof AuthLayoutRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLayoutRoute: AuthLayoutRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface DashboardLayoutRouteChildren {
  DashboardLayoutBrandRoute: typeof DashboardLayoutBrandRoute
  DashboardLayoutChatsRoute: typeof DashboardLayoutChatsRoute
  DashboardLayoutCommunityRoute: typeof DashboardLayoutCommunityRoute
  DashboardLayoutLibraryRoute: typeof DashboardLayoutLibraryRoute
  DashboardLayoutProductsRoute: typeof DashboardLayoutProductsRoute
  DashboardLayoutResearchRoute: typeof DashboardLayoutResearchRoute
  DashboardLayoutIndexRoute: typeof DashboardLayoutIndexRoute
}

const DashboardLayoutRouteChildren: DashboardLayoutRouteChildren = {
  DashboardLayoutBrandRoute: DashboardLayoutBrandRoute,
  DashboardLayoutChatsRoute: DashboardLayoutChatsRoute,
  DashboardLayoutCommunityRoute: DashboardLayoutCommunityRoute,
  DashboardLayoutLibraryRoute: DashboardLayoutLibraryRoute,
  DashboardLayoutProductsRoute: DashboardLayoutProductsRoute,
  DashboardLayoutResearchRoute: DashboardLayoutResearchRoute,
  DashboardLayoutIndexRoute: DashboardLayoutIndexRoute,
}

const DashboardLayoutRouteWithChildren = DashboardLayoutRoute._addFileChildren(
  DashboardLayoutRouteChildren,
)

interface DashboardResearchLayoutIdRouteChildren {
  DashboardResearchLayoutIdAudienceRoute: typeof DashboardResearchLayoutIdAudienceRoute
  DashboardResearchLayoutIdCompetitiveRoute: typeof DashboardResearchLayoutIdCompetitiveRoute
  DashboardResearchLayoutIdCreativeRoute: typeof DashboardResearchLayoutIdCreativeRoute
  DashboardResearchLayoutIdFoundationRoute: typeof DashboardResearchLayoutIdFoundationRoute
  DashboardResearchLayoutIdMarketRoute: typeof DashboardResearchLayoutIdMarketRoute
  DashboardResearchLayoutIdSocialRoute: typeof DashboardResearchLayoutIdSocialRoute
  DashboardResearchLayoutIdIndexRoute: typeof DashboardResearchLayoutIdIndexRoute
}

const DashboardResearchLayoutIdRouteChildren: DashboardResearchLayoutIdRouteChildren =
  {
    DashboardResearchLayoutIdAudienceRoute:
      DashboardResearchLayoutIdAudienceRoute,
    DashboardResearchLayoutIdCompetitiveRoute:
      DashboardResearchLayoutIdCompetitiveRoute,
    DashboardResearchLayoutIdCreativeRoute:
      DashboardResearchLayoutIdCreativeRoute,
    DashboardResearchLayoutIdFoundationRoute:
      DashboardResearchLayoutIdFoundationRoute,
    DashboardResearchLayoutIdMarketRoute: DashboardResearchLayoutIdMarketRoute,
    DashboardResearchLayoutIdSocialRoute: DashboardResearchLayoutIdSocialRoute,
    DashboardResearchLayoutIdIndexRoute: DashboardResearchLayoutIdIndexRoute,
  }

const DashboardResearchLayoutIdRouteWithChildren =
  DashboardResearchLayoutIdRoute._addFileChildren(
    DashboardResearchLayoutIdRouteChildren,
  )

interface DashboardResearchLayoutRouteChildren {
  DashboardResearchLayoutIdRoute: typeof DashboardResearchLayoutIdRouteWithChildren
}

const DashboardResearchLayoutRouteChildren: DashboardResearchLayoutRouteChildren =
  {
    DashboardResearchLayoutIdRoute: DashboardResearchLayoutIdRouteWithChildren,
  }

const DashboardResearchLayoutRouteWithChildren =
  DashboardResearchLayoutRoute._addFileChildren(
    DashboardResearchLayoutRouteChildren,
  )

interface DashboardResearchRouteChildren {
  DashboardResearchLayoutRoute: typeof DashboardResearchLayoutRouteWithChildren
}

const DashboardResearchRouteChildren: DashboardResearchRouteChildren = {
  DashboardResearchLayoutRoute: DashboardResearchLayoutRouteWithChildren,
}

const DashboardResearchRouteWithChildren =
  DashboardResearchRoute._addFileChildren(DashboardResearchRouteChildren)

interface DashboardSettingsLayoutRouteChildren {
  DashboardSettingsLayoutInvoicesRoute: typeof DashboardSettingsLayoutInvoicesRoute
  DashboardSettingsLayoutProfileRoute: typeof DashboardSettingsLayoutProfileRoute
  DashboardSettingsLayoutSubscriptionRoute: typeof DashboardSettingsLayoutSubscriptionRoute
  DashboardSettingsLayoutUsageRoute: typeof DashboardSettingsLayoutUsageRoute
}

const DashboardSettingsLayoutRouteChildren: DashboardSettingsLayoutRouteChildren =
  {
    DashboardSettingsLayoutInvoicesRoute: DashboardSettingsLayoutInvoicesRoute,
    DashboardSettingsLayoutProfileRoute: DashboardSettingsLayoutProfileRoute,
    DashboardSettingsLayoutSubscriptionRoute:
      DashboardSettingsLayoutSubscriptionRoute,
    DashboardSettingsLayoutUsageRoute: DashboardSettingsLayoutUsageRoute,
  }

const DashboardSettingsLayoutRouteWithChildren =
  DashboardSettingsLayoutRoute._addFileChildren(
    DashboardSettingsLayoutRouteChildren,
  )

interface DashboardSettingsRouteChildren {
  DashboardSettingsLayoutRoute: typeof DashboardSettingsLayoutRouteWithChildren
}

const DashboardSettingsRouteChildren: DashboardSettingsRouteChildren = {
  DashboardSettingsLayoutRoute: DashboardSettingsLayoutRouteWithChildren,
}

const DashboardSettingsRouteWithChildren =
  DashboardSettingsRoute._addFileChildren(DashboardSettingsRouteChildren)

interface DashboardRouteChildren {
  DashboardLayoutRoute: typeof DashboardLayoutRouteWithChildren
  DashboardChatSessionRoute: typeof DashboardChatSessionRoute
  DashboardResearchRoute: typeof DashboardResearchRouteWithChildren
  DashboardSettingsRoute: typeof DashboardSettingsRouteWithChildren
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardLayoutRoute: DashboardLayoutRouteWithChildren,
  DashboardChatSessionRoute: DashboardChatSessionRoute,
  DashboardResearchRoute: DashboardResearchRouteWithChildren,
  DashboardSettingsRoute: DashboardSettingsRouteWithChildren,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

interface OauthLayoutRouteChildren {
  OauthLayoutFacebookRoute: typeof OauthLayoutFacebookRoute
  OauthLayoutGoogleRoute: typeof OauthLayoutGoogleRoute
}

const OauthLayoutRouteChildren: OauthLayoutRouteChildren = {
  OauthLayoutFacebookRoute: OauthLayoutFacebookRoute,
  OauthLayoutGoogleRoute: OauthLayoutGoogleRoute,
}

const OauthLayoutRouteWithChildren = OauthLayoutRoute._addFileChildren(
  OauthLayoutRouteChildren,
)

interface OauthRouteChildren {
  OauthLayoutRoute: typeof OauthLayoutRouteWithChildren
}

const OauthRouteChildren: OauthRouteChildren = {
  OauthLayoutRoute: OauthLayoutRouteWithChildren,
}

const OauthRouteWithChildren = OauthRoute._addFileChildren(OauthRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRoute
  '/auth': typeof AuthLayoutRouteWithChildren
  '/dashboard': typeof DashboardLayoutRouteWithChildren
  '/external/auth': typeof ExternalAuthRoute
  '/oauth': typeof OauthLayoutRouteWithChildren
  '/chat/p/$session': typeof ChatPSessionRoute
  '/chat/r/$session': typeof ChatRSessionRoute
  '/dashboard/brand': typeof DashboardLayoutBrandRoute
  '/dashboard/chats': typeof DashboardLayoutChatsRoute
  '/dashboard/community': typeof DashboardLayoutCommunityRoute
  '/dashboard/library': typeof DashboardLayoutLibraryRoute
  '/dashboard/products': typeof DashboardLayoutProductsRoute
  '/dashboard/research': typeof DashboardResearchLayoutRouteWithChildren
  '/dashboard/chat/$session': typeof DashboardChatSessionRoute
  '/dashboard/settings': typeof DashboardSettingsLayoutRouteWithChildren
  '/oauth/facebook': typeof OauthLayoutFacebookRoute
  '/oauth/google': typeof OauthLayoutGoogleRoute
  '/auth/': typeof AuthLayoutIndexRoute
  '/dashboard/': typeof DashboardLayoutIndexRoute
  '/auth/callback/google': typeof AuthLayoutCallbackGoogleRoute
  '/auth/callback/magic-link': typeof AuthLayoutCallbackMagicLinkRoute
  '/dashboard/research/$id': typeof DashboardResearchLayoutIdRouteWithChildren
  '/dashboard/settings/invoices': typeof DashboardSettingsLayoutInvoicesRoute
  '/dashboard/settings/profile': typeof DashboardSettingsLayoutProfileRoute
  '/dashboard/settings/subscription': typeof DashboardSettingsLayoutSubscriptionRoute
  '/dashboard/settings/usage': typeof DashboardSettingsLayoutUsageRoute
  '/dashboard/research/$id/audience': typeof DashboardResearchLayoutIdAudienceRoute
  '/dashboard/research/$id/competitive': typeof DashboardResearchLayoutIdCompetitiveRoute
  '/dashboard/research/$id/creative': typeof DashboardResearchLayoutIdCreativeRoute
  '/dashboard/research/$id/foundation': typeof DashboardResearchLayoutIdFoundationRoute
  '/dashboard/research/$id/market': typeof DashboardResearchLayoutIdMarketRoute
  '/dashboard/research/$id/social': typeof DashboardResearchLayoutIdSocialRoute
  '/dashboard/research/$id/': typeof DashboardResearchLayoutIdIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRoute
  '/auth': typeof AuthLayoutIndexRoute
  '/dashboard': typeof DashboardLayoutIndexRoute
  '/external/auth': typeof ExternalAuthRoute
  '/oauth': typeof OauthLayoutRouteWithChildren
  '/chat/p/$session': typeof ChatPSessionRoute
  '/chat/r/$session': typeof ChatRSessionRoute
  '/dashboard/brand': typeof DashboardLayoutBrandRoute
  '/dashboard/chats': typeof DashboardLayoutChatsRoute
  '/dashboard/community': typeof DashboardLayoutCommunityRoute
  '/dashboard/library': typeof DashboardLayoutLibraryRoute
  '/dashboard/products': typeof DashboardLayoutProductsRoute
  '/dashboard/research': typeof DashboardResearchLayoutRouteWithChildren
  '/dashboard/chat/$session': typeof DashboardChatSessionRoute
  '/dashboard/settings': typeof DashboardSettingsLayoutRouteWithChildren
  '/oauth/facebook': typeof OauthLayoutFacebookRoute
  '/oauth/google': typeof OauthLayoutGoogleRoute
  '/auth/callback/google': typeof AuthLayoutCallbackGoogleRoute
  '/auth/callback/magic-link': typeof AuthLayoutCallbackMagicLinkRoute
  '/dashboard/settings/invoices': typeof DashboardSettingsLayoutInvoicesRoute
  '/dashboard/settings/profile': typeof DashboardSettingsLayoutProfileRoute
  '/dashboard/settings/subscription': typeof DashboardSettingsLayoutSubscriptionRoute
  '/dashboard/settings/usage': typeof DashboardSettingsLayoutUsageRoute
  '/dashboard/research/$id/audience': typeof DashboardResearchLayoutIdAudienceRoute
  '/dashboard/research/$id/competitive': typeof DashboardResearchLayoutIdCompetitiveRoute
  '/dashboard/research/$id/creative': typeof DashboardResearchLayoutIdCreativeRoute
  '/dashboard/research/$id/foundation': typeof DashboardResearchLayoutIdFoundationRoute
  '/dashboard/research/$id/market': typeof DashboardResearchLayoutIdMarketRoute
  '/dashboard/research/$id/social': typeof DashboardResearchLayoutIdSocialRoute
  '/dashboard/research/$id': typeof DashboardResearchLayoutIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRoute
  '/auth': typeof AuthRouteWithChildren
  '/auth/_layout': typeof AuthLayoutRouteWithChildren
  '/dashboard': typeof DashboardRouteWithChildren
  '/dashboard/_layout': typeof DashboardLayoutRouteWithChildren
  '/external/auth': typeof ExternalAuthRoute
  '/oauth': typeof OauthRouteWithChildren
  '/oauth/_layout': typeof OauthLayoutRouteWithChildren
  '/chat/p/$session': typeof ChatPSessionRoute
  '/chat/r/$session': typeof ChatRSessionRoute
  '/dashboard/_layout/brand': typeof DashboardLayoutBrandRoute
  '/dashboard/_layout/chats': typeof DashboardLayoutChatsRoute
  '/dashboard/_layout/community': typeof DashboardLayoutCommunityRoute
  '/dashboard/_layout/library': typeof DashboardLayoutLibraryRoute
  '/dashboard/_layout/products': typeof DashboardLayoutProductsRoute
  '/dashboard/_layout/research': typeof DashboardLayoutResearchRoute
  '/dashboard/chat/$session': typeof DashboardChatSessionRoute
  '/dashboard/research': typeof DashboardResearchRouteWithChildren
  '/dashboard/research/_layout': typeof DashboardResearchLayoutRouteWithChildren
  '/dashboard/settings': typeof DashboardSettingsRouteWithChildren
  '/dashboard/settings/_layout': typeof DashboardSettingsLayoutRouteWithChildren
  '/oauth/_layout/facebook': typeof OauthLayoutFacebookRoute
  '/oauth/_layout/google': typeof OauthLayoutGoogleRoute
  '/auth/_layout/': typeof AuthLayoutIndexRoute
  '/dashboard/_layout/': typeof DashboardLayoutIndexRoute
  '/auth/_layout/callback/google': typeof AuthLayoutCallbackGoogleRoute
  '/auth/_layout/callback/magic-link': typeof AuthLayoutCallbackMagicLinkRoute
  '/dashboard/research/_layout/$id': typeof DashboardResearchLayoutIdRouteWithChildren
  '/dashboard/settings/_layout/invoices': typeof DashboardSettingsLayoutInvoicesRoute
  '/dashboard/settings/_layout/profile': typeof DashboardSettingsLayoutProfileRoute
  '/dashboard/settings/_layout/subscription': typeof DashboardSettingsLayoutSubscriptionRoute
  '/dashboard/settings/_layout/usage': typeof DashboardSettingsLayoutUsageRoute
  '/dashboard/research/_layout/$id/audience': typeof DashboardResearchLayoutIdAudienceRoute
  '/dashboard/research/_layout/$id/competitive': typeof DashboardResearchLayoutIdCompetitiveRoute
  '/dashboard/research/_layout/$id/creative': typeof DashboardResearchLayoutIdCreativeRoute
  '/dashboard/research/_layout/$id/foundation': typeof DashboardResearchLayoutIdFoundationRoute
  '/dashboard/research/_layout/$id/market': typeof DashboardResearchLayoutIdMarketRoute
  '/dashboard/research/_layout/$id/social': typeof DashboardResearchLayoutIdSocialRoute
  '/dashboard/research/_layout/$id/': typeof DashboardResearchLayoutIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/onboarding'
    | '/auth'
    | '/dashboard'
    | '/external/auth'
    | '/oauth'
    | '/chat/p/$session'
    | '/chat/r/$session'
    | '/dashboard/brand'
    | '/dashboard/chats'
    | '/dashboard/community'
    | '/dashboard/library'
    | '/dashboard/products'
    | '/dashboard/research'
    | '/dashboard/chat/$session'
    | '/dashboard/settings'
    | '/oauth/facebook'
    | '/oauth/google'
    | '/auth/'
    | '/dashboard/'
    | '/auth/callback/google'
    | '/auth/callback/magic-link'
    | '/dashboard/research/$id'
    | '/dashboard/settings/invoices'
    | '/dashboard/settings/profile'
    | '/dashboard/settings/subscription'
    | '/dashboard/settings/usage'
    | '/dashboard/research/$id/audience'
    | '/dashboard/research/$id/competitive'
    | '/dashboard/research/$id/creative'
    | '/dashboard/research/$id/foundation'
    | '/dashboard/research/$id/market'
    | '/dashboard/research/$id/social'
    | '/dashboard/research/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/onboarding'
    | '/auth'
    | '/dashboard'
    | '/external/auth'
    | '/oauth'
    | '/chat/p/$session'
    | '/chat/r/$session'
    | '/dashboard/brand'
    | '/dashboard/chats'
    | '/dashboard/community'
    | '/dashboard/library'
    | '/dashboard/products'
    | '/dashboard/research'
    | '/dashboard/chat/$session'
    | '/dashboard/settings'
    | '/oauth/facebook'
    | '/oauth/google'
    | '/auth/callback/google'
    | '/auth/callback/magic-link'
    | '/dashboard/settings/invoices'
    | '/dashboard/settings/profile'
    | '/dashboard/settings/subscription'
    | '/dashboard/settings/usage'
    | '/dashboard/research/$id/audience'
    | '/dashboard/research/$id/competitive'
    | '/dashboard/research/$id/creative'
    | '/dashboard/research/$id/foundation'
    | '/dashboard/research/$id/market'
    | '/dashboard/research/$id/social'
    | '/dashboard/research/$id'
  id:
    | '__root__'
    | '/'
    | '/onboarding'
    | '/auth'
    | '/auth/_layout'
    | '/dashboard'
    | '/dashboard/_layout'
    | '/external/auth'
    | '/oauth'
    | '/oauth/_layout'
    | '/chat/p/$session'
    | '/chat/r/$session'
    | '/dashboard/_layout/brand'
    | '/dashboard/_layout/chats'
    | '/dashboard/_layout/community'
    | '/dashboard/_layout/library'
    | '/dashboard/_layout/products'
    | '/dashboard/_layout/research'
    | '/dashboard/chat/$session'
    | '/dashboard/research'
    | '/dashboard/research/_layout'
    | '/dashboard/settings'
    | '/dashboard/settings/_layout'
    | '/oauth/_layout/facebook'
    | '/oauth/_layout/google'
    | '/auth/_layout/'
    | '/dashboard/_layout/'
    | '/auth/_layout/callback/google'
    | '/auth/_layout/callback/magic-link'
    | '/dashboard/research/_layout/$id'
    | '/dashboard/settings/_layout/invoices'
    | '/dashboard/settings/_layout/profile'
    | '/dashboard/settings/_layout/subscription'
    | '/dashboard/settings/_layout/usage'
    | '/dashboard/research/_layout/$id/audience'
    | '/dashboard/research/_layout/$id/competitive'
    | '/dashboard/research/_layout/$id/creative'
    | '/dashboard/research/_layout/$id/foundation'
    | '/dashboard/research/_layout/$id/market'
    | '/dashboard/research/_layout/$id/social'
    | '/dashboard/research/_layout/$id/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  OnboardingRoute: typeof OnboardingRoute
  AuthRoute: typeof AuthRouteWithChildren
  DashboardRoute: typeof DashboardRouteWithChildren
  ExternalAuthRoute: typeof ExternalAuthRoute
  OauthRoute: typeof OauthRouteWithChildren
  ChatPSessionRoute: typeof ChatPSessionRoute
  ChatRSessionRoute: typeof ChatRSessionRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  OnboardingRoute: OnboardingRoute,
  AuthRoute: AuthRouteWithChildren,
  DashboardRoute: DashboardRouteWithChildren,
  ExternalAuthRoute: ExternalAuthRoute,
  OauthRoute: OauthRouteWithChildren,
  ChatPSessionRoute: ChatPSessionRoute,
  ChatRSessionRoute: ChatRSessionRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/onboarding",
        "/auth",
        "/dashboard",
        "/external/auth",
        "/oauth",
        "/chat/p/$session",
        "/chat/r/$session"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/onboarding": {
      "filePath": "onboarding.tsx"
    },
    "/auth": {
      "filePath": "auth",
      "children": [
        "/auth/_layout"
      ]
    },
    "/auth/_layout": {
      "filePath": "auth/_layout.tsx",
      "parent": "/auth",
      "children": [
        "/auth/_layout/",
        "/auth/_layout/callback/google",
        "/auth/_layout/callback/magic-link"
      ]
    },
    "/dashboard": {
      "filePath": "dashboard",
      "children": [
        "/dashboard/_layout",
        "/dashboard/chat/$session",
        "/dashboard/research",
        "/dashboard/settings"
      ]
    },
    "/dashboard/_layout": {
      "filePath": "dashboard/_layout.tsx",
      "parent": "/dashboard",
      "children": [
        "/dashboard/_layout/brand",
        "/dashboard/_layout/chats",
        "/dashboard/_layout/community",
        "/dashboard/_layout/library",
        "/dashboard/_layout/products",
        "/dashboard/_layout/research",
        "/dashboard/_layout/"
      ]
    },
    "/external/auth": {
      "filePath": "external/auth.tsx"
    },
    "/oauth": {
      "filePath": "oauth",
      "children": [
        "/oauth/_layout"
      ]
    },
    "/oauth/_layout": {
      "filePath": "oauth/_layout.tsx",
      "parent": "/oauth",
      "children": [
        "/oauth/_layout/facebook",
        "/oauth/_layout/google"
      ]
    },
    "/chat/p/$session": {
      "filePath": "chat/p.$session.tsx"
    },
    "/chat/r/$session": {
      "filePath": "chat/r.$session.tsx"
    },
    "/dashboard/_layout/brand": {
      "filePath": "dashboard/_layout.brand.tsx",
      "parent": "/dashboard/_layout"
    },
    "/dashboard/_layout/chats": {
      "filePath": "dashboard/_layout.chats.tsx",
      "parent": "/dashboard/_layout"
    },
    "/dashboard/_layout/community": {
      "filePath": "dashboard/_layout.community.tsx",
      "parent": "/dashboard/_layout"
    },
    "/dashboard/_layout/library": {
      "filePath": "dashboard/_layout.library.tsx",
      "parent": "/dashboard/_layout"
    },
    "/dashboard/_layout/products": {
      "filePath": "dashboard/_layout.products.tsx",
      "parent": "/dashboard/_layout"
    },
    "/dashboard/_layout/research": {
      "filePath": "dashboard/_layout.research.tsx",
      "parent": "/dashboard/_layout"
    },
    "/dashboard/chat/$session": {
      "filePath": "dashboard/chat/$session.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/research": {
      "filePath": "dashboard/research",
      "parent": "/dashboard",
      "children": [
        "/dashboard/research/_layout"
      ]
    },
    "/dashboard/research/_layout": {
      "filePath": "dashboard/research/_layout.tsx",
      "parent": "/dashboard/research",
      "children": [
        "/dashboard/research/_layout/$id"
      ]
    },
    "/dashboard/settings": {
      "filePath": "dashboard/settings",
      "parent": "/dashboard",
      "children": [
        "/dashboard/settings/_layout"
      ]
    },
    "/dashboard/settings/_layout": {
      "filePath": "dashboard/settings/_layout.tsx",
      "parent": "/dashboard/settings",
      "children": [
        "/dashboard/settings/_layout/invoices",
        "/dashboard/settings/_layout/profile",
        "/dashboard/settings/_layout/subscription",
        "/dashboard/settings/_layout/usage"
      ]
    },
    "/oauth/_layout/facebook": {
      "filePath": "oauth/_layout.facebook.tsx",
      "parent": "/oauth/_layout"
    },
    "/oauth/_layout/google": {
      "filePath": "oauth/_layout.google.tsx",
      "parent": "/oauth/_layout"
    },
    "/auth/_layout/": {
      "filePath": "auth/_layout.index.tsx",
      "parent": "/auth/_layout"
    },
    "/dashboard/_layout/": {
      "filePath": "dashboard/_layout.index.tsx",
      "parent": "/dashboard/_layout"
    },
    "/auth/_layout/callback/google": {
      "filePath": "auth/_layout.callback.google.tsx",
      "parent": "/auth/_layout"
    },
    "/auth/_layout/callback/magic-link": {
      "filePath": "auth/_layout.callback.magic-link.tsx",
      "parent": "/auth/_layout"
    },
    "/dashboard/research/_layout/$id": {
      "filePath": "dashboard/research/_layout.$id.tsx",
      "parent": "/dashboard/research/_layout",
      "children": [
        "/dashboard/research/_layout/$id/audience",
        "/dashboard/research/_layout/$id/competitive",
        "/dashboard/research/_layout/$id/creative",
        "/dashboard/research/_layout/$id/foundation",
        "/dashboard/research/_layout/$id/market",
        "/dashboard/research/_layout/$id/social",
        "/dashboard/research/_layout/$id/"
      ]
    },
    "/dashboard/settings/_layout/invoices": {
      "filePath": "dashboard/settings/_layout.invoices.tsx",
      "parent": "/dashboard/settings/_layout"
    },
    "/dashboard/settings/_layout/profile": {
      "filePath": "dashboard/settings/_layout.profile.tsx",
      "parent": "/dashboard/settings/_layout"
    },
    "/dashboard/settings/_layout/subscription": {
      "filePath": "dashboard/settings/_layout.subscription.tsx",
      "parent": "/dashboard/settings/_layout"
    },
    "/dashboard/settings/_layout/usage": {
      "filePath": "dashboard/settings/_layout.usage.tsx",
      "parent": "/dashboard/settings/_layout"
    },
    "/dashboard/research/_layout/$id/audience": {
      "filePath": "dashboard/research/_layout.$id.audience.tsx",
      "parent": "/dashboard/research/_layout/$id"
    },
    "/dashboard/research/_layout/$id/competitive": {
      "filePath": "dashboard/research/_layout.$id.competitive.tsx",
      "parent": "/dashboard/research/_layout/$id"
    },
    "/dashboard/research/_layout/$id/creative": {
      "filePath": "dashboard/research/_layout.$id.creative.tsx",
      "parent": "/dashboard/research/_layout/$id"
    },
    "/dashboard/research/_layout/$id/foundation": {
      "filePath": "dashboard/research/_layout.$id.foundation.tsx",
      "parent": "/dashboard/research/_layout/$id"
    },
    "/dashboard/research/_layout/$id/market": {
      "filePath": "dashboard/research/_layout.$id.market.tsx",
      "parent": "/dashboard/research/_layout/$id"
    },
    "/dashboard/research/_layout/$id/social": {
      "filePath": "dashboard/research/_layout.$id.social.tsx",
      "parent": "/dashboard/research/_layout/$id"
    },
    "/dashboard/research/_layout/$id/": {
      "filePath": "dashboard/research/_layout.$id.index.tsx",
      "parent": "/dashboard/research/_layout/$id"
    }
  }
}
ROUTE_MANIFEST_END */
